var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.contact)?_c('div',{staticClass:"contact-section"},[_c('h1',[_vm._v("Contact Me!")]),_c('h2',[_vm._v("Have a question or want to work together?")]),_c('contact-form')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }